import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Report from "../../../models/Report";
import DataTable from "../dataTable";

const initialTable = {
    page: 1,
    term: "",
    sort: "cancelledNoAvailabilityPercentage",
    order: "asc",
    limit: 25,
};

const percentageText = (value) => `${Number(value || 0).toFixed(2)}%`;

export default function GolfClubTeeTimeBookingOutcomeMix() {
    const [loading, setLoading] = useState(true);
    const [table, setTable] = useState(initialTable);
    const [totalRecords, setTotalRecords] = useState(0);
    const [data, setData] = useState([]);

    const getData = useCallback(async (params) => {
        setLoading(true);
        const response = await Report.golfClubTeeTimeBookingOutcomeMix(params);
        setData(response.items);
        setTotalRecords(response.total);
        setTable(params);
        setLoading(false);
    }, []);

    useEffect(() => {
        getData(initialTable);
    }, [getData]);

    const headers = [
        { key: "golfClub", text: "Golf club" },
        { key: "booked", text: "Booked" },
        { key: "cancelledNoAvailability", text: "Cancelled no availability" },
        { key: "cancelledOther", text: "Cancelled other" },
        { key: "totalIncludedBookings", text: "Total included" },
    ];
    const tableData = data.map((item) => {
        return {
            golfClub: {
                value: (
                    <Link to={`/golf-clubs/${item._id}`}>{item.name}</Link>
                ),
                search: item.name,
            },
            booked: {
                value: `${item.booked} (${percentageText(
                    item.bookedPercentage,
                )})`,
                search: item.bookedPercentage,
            },
            cancelledNoAvailability: {
                value: `${item.cancelledNoAvailability} (${percentageText(
                    item.cancelledNoAvailabilityPercentage,
                )})`,
                search: item.cancelledNoAvailabilityPercentage,
            },
            cancelledOther: {
                value: `${item.cancelledOther} (${percentageText(
                    item.cancelledOtherPercentage,
                )})`,
                search: item.cancelledOtherPercentage,
            },
            totalIncludedBookings: {
                value: item.totalIncludedBookings,
                search: item.totalIncludedBookings,
            },
        };
    });

    return (
        <>
            <h4>Golf club tee-time booking outcome mix</h4>
            <p>
                The all-time split of played bookings and cancelled tee-time
                requests with cancellation reasons by golf club.
            </p>
            <DataTable
                loading={loading}
                headers={headers}
                data={tableData}
                totalRecords={totalRecords}
                page={table.page}
                onChange={getData}
                searchTerm={table.term}
                sort={table.sort}
                order={table.order}
                limit={table.limit}
                sortOptions={[
                    {
                        text: "% cancelled no availability",
                        key: "cancelledNoAvailabilityPercentage",
                    },
                    { text: "% booked", key: "bookedPercentage" },
                    {
                        text: "% cancelled other",
                        key: "cancelledOtherPercentage",
                    },
                    { text: "Golf club", key: "name" },
                    { text: "Total included", key: "totalIncludedBookings" },
                ]}
                pagination
            />
        </>
    );
}
